import {Injectable} from "@angular/core";
import {APIProxy, HttpObservable} from "../../../../http/services";
import {ISvgIcon} from "../interfaces/svg.icon";

@Injectable({providedIn: "root"})
export class SvgIconsProxy {
	constructor(private http: APIProxy) { }

	public getSvgIcons(): HttpObservable<ISvgIcon[]> {
		return this.http.getAnon("Icons", "GetSvgIcons");
	}
}
